import { addStyles } from 'ethcss'
import item from 'blocks.simple/item/item.jcss'
import { textSizes } from 'theme/media'
import { colors, IStyles, grid, mediaCSS } from '../../../theme'

const dashboardDevicesStyles: IStyles = {
    halfWidth: {
        width: '49%',
    },
    fullWidth: {
        width: '100%',
    },
    statusBlock: {
        backgroundColor: 'pink',
        borderRadius: '10px',
        padding: '10px',
        marginBottom: '10px',
    },
    wrapper: {
        ...grid.row,
        justifyContent: 'space-between',
        [mediaCSS.mob]: {
            marginBottom: 20,
        },
    },
    content: {
        ...grid.w50,
        ...grid.mt_mini,
    },
    title: {
        display: 'flex',
        justifyContent: 'space-between',
        textTransform: 'uppercase',
        color: colors.white,
    },
    info: {
        marginTop: '18px',
        fontSize: '64px',
        fontWeight: 600,
        lineHeight: 1,
        textAlign: 'right',
        color: colors.white,
    },
    link: {
        textDecoration: 'none',
    },
    footer: {
        ...item.abs,
        bottom: '6px',
        right: '6px',
        fontSize: textSizes.mini,
        [mediaCSS.mob]: {
            left: 12,
            bottom: 24,
        },
    },
    virtualSwitch: {
        position: 'absolute',
        bottom: 3,
        left: 10,
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,

        span: {
            marginLeft: 6,
        },
    },
}

addStyles(dashboardDevicesStyles)
export default dashboardDevicesStyles
